import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { getUrlByTargetContent } from '../../utils/utils';
import styles from './WpReco.module.less';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const [showWallpapers, setShowWallpapers] = useState([]);
  const [showRank, setShowRank] = useState({});

  const LOG_ACTION_SOURCE = {
    action_more: `C_${logInfo.tag}_Group_More`,
    source: `${logInfo.tag}_Group`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
      });
    }
  }, [inView]);

  const getClassType = useCallback(index => {
    const pos = index % 8;
    if (pos > 2 && pos < 5) {
      if (pos === 3) {
        return 'big_space';
      }
      return 'big';
    }
    if (pos === 1 || pos === 6) {
      return 'small_center';
    }
    return 'small';
  }, []);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (
      data &&
      data.dataList &&
      data.dataList.length > 0 &&
      data.dataList[0].wallpaperList &&
      data.dataList[0].wallpaperList.length > 0
    ) {
      // 3 2 3的展示规则，计算显示的壁纸张数
      const row = parseInt(data.row) || 1;
      let pageSize = parseInt(row / 3) * 8 + (row % 3 === 1 ? 3 : row % 3 === 2 ? 5 : 0);
      if (pageSize > data.dataList[0].wallpaperList.length) {
        pageSize = 3;
      }
      if (data.dataList[0].wallpaperList.length >= 3) {
        setShowWallpapers(data.dataList[0].wallpaperList.slice(0, pageSize));
        setShowRank(data.dataList[0]);
      }
    }
  }, [dispatch, data]);

  const handleShowMore = useCallback(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: LOG_ACTION_SOURCE.action_more,
        label: '',
        param2: {
          source: `${LOG_ACTION_SOURCE.source}||${showRank.pageCardContentId}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          code: showRank.code,
          title: data.title,
        },
      }),
    );

    if (data.targetType === '1' || data.targetType === '3' || data.targetType === '11') {
      dispatch(
        logPostInfo({
          source_p: `${LOG_ACTION_SOURCE.source}||${showRank.pageCardContentId}`,
          source_pp: logInfoData.source_p,
        }),
      );
      if (data.targetType && data.targetContent) {
        const url = getUrlByTargetContent(data);
        history.push(url);
      } else {
        history.push(`${CONTEXT}/wpcategory`);
      }
    } else if (data.targetType === '2' && data.targetUrl) {
      window.open(data.targetUrl);
    }
  }, [showRank]);

  return showWallpapers && showWallpapers.length > 0 ? (
    <div className={styles.card} ref={ref}>
      <div className={styles.card_header}>
        <div className={styles.card_header_title}>{data.title}</div>
        {data.operate === '2' && data.targetType && data.targetContent && (
          <div
            className={styles.card_header_opt}
            onClick={() => {
              handleShowMore();
            }}
          >
            查看更多
          </div>
        )}
      </div>
      <div className={styles.card_wplist}>
        {showWallpapers.map((item, index) => {
          return (
            <WallpaperCard
              wallpaper={item}
              key={index}
              cardInfo={{
                pageSource: 'rank',
                code: data.dataList[0].code || '1',
                classType: getClassType(index),
                isCollect: true,
                isWallpaper: true,
                isDeleteColl: false,
                isDeleteUsed: false,
                isPreview: true,
              }}
              logInfo={{ source: `${LOG_ACTION_SOURCE.source}||${showRank.pageCardContentId}` }}
            />
          );
        })}
      </div>
    </div>
  ) : (
    ''
  );
});
